import React from 'react'
import { Empty } from 'antd'
import styled from '@emotion/styled'
import { H3, P1, NEUTRAL_COLORS, Button } from '@xfers/design-system'
import StraitsxEmptyWithPattern from '~/assets/emptyState.svg'

type EmptyDataProps = {
  title?: string
  subtitle?: string
  info?: React.ReactNode
  onButtonClick?: () => void
  buttonLabel?: string
}

const StraitsXEmptyData = ({
  title = 'No results found',
  subtitle,
  info,
  onButtonClick,
  buttonLabel = 'Make A Transfer',
}: EmptyDataProps) => {
  const centerSvgStyle = {
    marginBottom: 10,
    display: 'block',
    margin: 'auto',
    height: '80px',
    width: '130px',
  }
  return (
    <Container>
      <Empty image={StraitsxEmptyWithPattern} imageStyle={centerSvgStyle} description={false} />
      <TextContainer>
        {title && <Title data-qa-test>{title}</Title>}
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        {info && <Info>{info}</Info>}
      </TextContainer>
      {onButtonClick && (
        <div style={{ textAlign: 'center' }}>
          <Button
            type="primary"
            size="small"
            onClick={() => {
              onButtonClick()
            }}
          >
            {buttonLabel}
          </Button>
        </div>
      )}
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
`
const TextContainer = styled.div`
  gap: 4px;
`
const Title = styled(H3)`
  text-align: center;
`

const Subtitle = styled(P1)`
  text-align: center;
  color: ${NEUTRAL_COLORS.BLACK};
  align-items: center;
`

const Info = styled(P1)`
  text-align: center;
  color: ${NEUTRAL_COLORS.BLACK};
  align-items: center;
`

export default StraitsXEmptyData
